module.exports = __webpack_public_path__ + "vue-app/img/best-price-fr.1302238b.svg";